@use "~theme/typography";
@use "~theme/breakpoints";

.container {
  display: flex;
  padding: 16px 20px;
  background-color: var(--white);
  // border-bottom: 1px solid var(--blue-01-at-30);
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @include breakpoints.desktop {
    margin-right: 16px;
    padding-left: 0;
    border-bottom: 4px solid var(--blue-01);

    &:focus-within {
      outline: 2px solid var(--blue-02-at-30);
    }
  }
}

.containerFuture {
  order: 1;

  @include breakpoints.desktop {
    border-color: var(--gray-01);
  }
}

.containerVisited {
  @include breakpoints.desktop {
    border-color: var(--blue-01-at-30);
  }
}

.label {
  @include typography.heading4;
  color: var(--blue-01);
  margin: 0;
  padding: 0;
  flex: 1;
}

.future {
  color: var(--black-at-75);
}

.visited {
  color: var(--black-at-75);
}

.icon {
  margin-right: 8px;
}

.editLink {
  color: var(--blue-02);

  &:focus {
    outline: 1px solid var(--blue-02);
  }

  @include breakpoints.desktop {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
